<template>
    <div class="notice-detail">
        <el-container>
            <el-header style="height:auto;">
                <p class="detail-title">{{noticeDetail.noticeTitle}}</p>
                <p class="detail-publisher">
                    <span style="font-weight:600;">发布人</span>:&nbsp;{{noticeDetail.trueName}}&nbsp;&nbsp;&nbsp;&nbsp;
                    <span style="font-weight:600;">发布时间</span>:&nbsp;{{noticeDetail.noticeDate}}
                </p>
            </el-header>
            <el-main shadow="always">
                <div class="notice-content">
                    <p v-html="noticeDetail.noticeContent"></p>
                </div>
            </el-main>
        </el-container>
    </div>
</template>

<script>
    import { getNoticeDetail } from '@/data-model';
    import mixinsNav from '@/mixins/mixins-nav';

    export default {
        mixins: [ mixinsNav ],
        data () {
            return {
                loadTimer: '',
                noticeDetail: {}
            };
        },
        props: {
            notice: {
                type: Object
            }
        },
        created () {
            this._initPage();
        },
        methods: {
            async _initPage () {
                let id = this.notice.id;
                if (id) {
                    this.noticeDetail = await getNoticeDetail(id);
                } else {
                    this.noticeDetail = {};
                }
            }
        }
    };
</script>

<style lang="less">
    .notice-detail {
        width: 100%;
        margin-top: 15px;
        .detail-title{
            text-align: center;
            font-size: 26px;
            font-weight: 700;
        }
        .detail-publisher{
            text-align: right;
            margin-right: 100px;
        }
        .notice-content {
            display: -webkit-flex;  
            -webkit-justify-content: center;  
            -webkit-align-items: center; 
            table {
              border:none;
              border-collapse:collapse;
            }
            table td,
            table th{
              border: 1px solid #ccc;
              padding: 3px 5px;
              min-width: 50px;
              height: 20px;
            }
            table th {
              border-right: 1px solid #ccc;
              border-bottom: 2px solid #ccc;
              text-align: center;
              background-color: #f1f1f1;
            }
            blockquote{
              display: block;
              border-left: 8px solid #d0e5f2;
              padding: 5px 10px;
              margin: 10px 0;
              line-height: 1.4;
              font-size: 100%;
              background-color: #f1f1f1;
            }
            code{
              display: inline-block;
              *display: inline;
              *zoom: 1;
              background-color: #f1f1f1;
              border-radius: 3px;
              padding: 3px 5px;
              margin: 0 3px;    
            }
            pre code {
              display: block;
            }
            ul, ol{
              margin: 10px 0 10px 20px;
            }
            pre {
              border: 1px solid #ccc;
              background-color: #f8f8f8;
              padding: 10px;
              margin: 5px 0px;
              font-size: 0.8em;
              border-radius: 3px;
            }
            .ql-editor ul li {
                list-style-type: disc;    // 解决序列li前面的.不展示问题
            }
            .ql-editor ol li {
                list-style-type: decimal;   // 解决序列li前面的数字不展示问题
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/application/Notice/NoticeDetail/NoticeDetail.vue